import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/PaymentTermRule";

export const GetAll = (options) => GENERATE_URL(PREFIX_URL, options);
export const Create = () => GENERATE_URL(PREFIX_URL);
export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);
export const UpdateActive = (options) =>
  GENERATE_URL(`${PREFIX_URL}/SetActive/:id`, options);

export default { GetAll, Create, Update, UpdateActive };
